import axios from "axios";
/* import json from "/public/json/index2.json" */

function compare(a, b) {
  if (a.properties.datetime > b.properties.datetime) {
    return -1;
  }
  if (a.properties.datetime < b.properties.datetime) {
    return 1;
  }
  return 0;
}

const state = {
  images: [],
  selectedDates: [],
  filteredImages: [],
};

const getters = {
  getImages: (state) => state.images,
  getFilteredImages: (state) => state.filteredImages,
  getSelectedDates: (state) => state.selectedDates,
};

const actions = {
  async fetchImages({ commit }) {
    try {
      const response = await axios.get("json/index.json", {
        baseURL: "https://observations.ipsl.fr/aeris/eurec4a-data/AIRCRAFT/HALO/PHOTOCOLLECTION-APP/",
      });
      await commit("setImages", response.data.features);
      commit("setSelectedDates");
      commit("applyFilters");
    } catch (error) {
      console.log(error);
    }
  },
};

const mutations = {
  setImages: (state, images) => (state.images = images.sort(compare)),
  setSelectedDates: (state) =>
    (state.selectedDates = [
      ...new Set(
        state.images.map(
          (i) => new Date(i.properties.datetime).toISOString().split("T")[0]
        )
      ),
    ]),
  updateFilterDates: (state, dates) => (state.selectedDates = dates),
  applyFilters: (state) => {
    /* let checker = (arr, target) => target.every((v) => arr.includes(v)); */
    state.filteredImages = state.images.filter((i) =>
      state.selectedDates.includes(
        new Date(i.properties.datetime).toISOString().split("T")[0]
      )
    );
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
